var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FFC83E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9993 31.9981C43.313 31.9981 45.9993 29.3123 45.9993 25.9991C45.9993 22.6859 43.313 20 39.9993 20C36.6856 20 33.9993 22.6859 33.9993 25.9991C33.9993 29.3123 36.6856 31.9981 39.9993 31.9981Z",
    stroke: "#FFC83E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 59.9937V31.998",
    stroke: "#FFC83E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40.0032H20C20 45.3067 22.1071 50.393 25.8579 54.1431C29.6086 57.8932 34.6957 60 40 60C45.3043 60 50.3914 57.8932 54.1421 54.1431C57.8929 50.393 60 45.3067 60 40.0032H54",
    stroke: "#FFC83E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIntegration);
export default __webpack_public_path__ + "static/media/AppIntegration.c9404e4a323171b0d075ebe60a4d99a3.svg";
export { ForwardRef as ReactComponent };